import { render, staticRenderFns } from "./one-music.vue?vue&type=template&id=34d70f06&"
import script from "./one-music.vue?vue&type=script&lang=js&"
export * from "./one-music.vue?vue&type=script&lang=js&"
import style0 from "./one-music.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports